import React from 'react';
export function PrivacyPolicyContent() {
  return <>
      <p className="mb-2.5" data-id="element-241">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-242">
        1. Información que Recopilamos
      </h3>
      <p className="mb-2.5" data-id="element-243">
        Recopilamos la información que nos proporcionas directamente al realizar
        una compra, incluyendo nombre, dirección de correo electrónico e
        información de pago procesada de forma segura a través de nuestro
        procesador de pagos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-244">
        2. Uso de la Información
      </h3>
      <p className="mb-2.5" data-id="element-245">
        Utilizamos tu información exclusivamente para procesar tu pedido, enviar
        los materiales digitales adquiridos y para comunicaciones relacionadas
        con tu compra.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-246">
        3. Cookies y Tecnologías de Seguimiento
      </h3>
      <p className="mb-2.5" data-id="element-247">
        Utilizamos cookies y el Meta Pixel para mejorar tu experiencia y
        optimizar nuestras campañas publicitarias. Puedes desactivar las cookies
        en la configuración de tu navegador.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-248">
        4. Compartir Información
      </h3>
      <p className="mb-2.5" data-id="element-249">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a aquellos necesarios para procesar tu pago y entregar
        tu pedido (procesadores de pago y plataformas de entrega digital).
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-250">5. Seguridad</h3>
      <p className="mb-2.5" data-id="element-251">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Todas las transacciones se procesan
        con cifrado SSL.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-252">6. Tus Derechos</h3>
      <p className="mb-2.5" data-id="element-253">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tu
        información personal. Para ejercer estos derechos, puedes contactarnos a
        través de nuestra plataforma de soporte.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-254">
        7. Cambios a Esta Política
      </h3>
      <p className="mb-2.5" data-id="element-255">
        Nos reservamos el derecho de actualizar esta política. Los cambios
        significativos serán notificados a través de nuestro sitio web.
      </p>
    </>;
}
export function TermsOfServiceContent() {
  return <>
      <p className="mb-2.5" data-id="element-256">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-257">
        1. Aceptación de los Términos
      </h3>
      <p className="mb-2.5" data-id="element-258">
        Al comprar cualquier producto de B.E.BE 365, aceptas estos términos de
        servicio en su totalidad. Si no estás de acuerdo con alguno de estos
        términos, no debes utilizar nuestros productos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-259">
        2. Productos Digitales
      </h3>
      <p className="mb-2.5" data-id="element-260">
        Todos nuestros productos son descargas digitales. Recibirás acceso
        inmediato a través del correo electrónico proporcionado en la compra. No
        se envían productos físicos.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-261">3. Licencia de Uso</h3>
      <p className="mb-2.5" data-id="element-262">
        Al comprar nuestros productos, obtienes una licencia personal e
        intransferible solo para uso personal. La redistribución, venta o
        intercambio de los materiales con terceros está estrictamente prohibida.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-263">
        4. Política de Reembolso
      </h3>
      <p className="mb-2.5" data-id="element-264">
        Ofrecemos una garantía de satisfacción de 30 días. Si no estás
        satisfecho con tu compra, puedes solicitar un reembolso completo dentro
        de los 30 días posteriores a la compra a través de nuestra plataforma de
        soporte.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-265">
        5. Propiedad Intelectual
      </h3>
      <p className="mb-2.5" data-id="element-266">
        Todo el contenido de B.E.BE 365, incluyendo textos, imágenes, diseños y
        metodologías, está protegido por derechos de autor. La reproducción sin
        autorización expresa está prohibida.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-267">
        6. Limitación de Responsabilidad
      </h3>
      <p className="mb-2.5" data-id="element-268">
        B.E.BE 365 proporciona información educativa. No somos responsables de
        las decisiones tomadas en base a nuestro contenido. Siempre consulta a
        profesionales de la salud para decisiones médicas.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-269">7. Modificaciones</h3>
      <p className="mb-2.5" data-id="element-270">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. El uso continuo de nuestros productos constituye la aceptación
        de los términos modificados.
      </p>
    </>;
}
export function DisclaimerContent() {
  return <>
      <p className="mb-2.5" data-id="element-271">Última actualización: Enero 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-272">
        Propósito Educativo
      </h3>
      <p className="mb-2.5" data-id="element-273">
        Todo el contenido de B.E.BE 365, incluyendo el Protocolo Principal y los
        4 Bonos, es de naturaleza exclusivamente educativa e informativa. No
        constituye consejo médico, diagnóstico ni tratamiento.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-274">
        Consulta Profesional
      </h3>
      <p className="mb-2.5" data-id="element-275">
        Siempre consulta con tu pediatra, médico de familia u otro profesional
        de la salud calificado antes de implementar cambios en la rutina de tu
        bebé, especialmente en lo que respecta al sueño, la alimentación o el
        desarrollo.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-276">
        Resultados No Garantizados
      </h3>
      <p className="mb-2.5" data-id="element-277">
        Los resultados mencionados en este sitio son experiencias individuales y
        no son típicos ni están garantizados. Cada bebé es único y los
        resultados variarán según múltiples factores, incluyendo la edad, el
        temperamento y la consistencia en la aplicación.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-278">Testimonios</h3>
      <p className="mb-2.5" data-id="element-279">
        Los testimonios presentados en este sitio son experiencias reales de
        usuarios pero no representan resultados típicos. No garantizamos que
        obtendrás los mismos resultados.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-280">Afiliación</h3>
      <p className="mb-2.5" data-id="element-281">
        Este sitio no está afiliado, asociado, autorizado, respaldado por, ni
        conectado oficialmente de ninguna manera con Meta Platforms Inc.,
        Facebook™, Instagram™, WhatsApp™, o cualquier otra empresa mencionada
        en este sitio.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-282">
        Emergencias Médicas
      </h3>
      <p className="mb-2.5" data-id="element-283">
        Si tu bebé presenta síntomas de una emergencia médica, llama
        inmediatamente a los servicios de emergencia de tu país. No utilices
        este material como sustituto de atención médica de emergencia.
      </p>
    </>;
}